import Card from './card';
import List from './list';
const OPCard = Card;
OPCard.List = List;
export default OPCard;
